import { render, staticRenderFns } from "./WorksNavi.vue?vue&type=template&id=6d7b4104&lang=pug&"
import script from "./WorksNavi.vue?vue&type=script&lang=js&"
export * from "./WorksNavi.vue?vue&type=script&lang=js&"
import style0 from "./WorksNavi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports